<template>
	<div :class="{'text-primary': selectedComponentId == component.id}">
		<span v-if="'item_number' in component && component.item_number">{{ component.item_number }}. </span>
		{{ component.name }}

		<ul v-if="'descendants' in component && component.descendants" class="node-children">
			<li v-for="(childComp,index) in component.descendants">
				<bid-tree-node 
					:component="childComp"
					:is-last-one="index == component.descendants.length - 1"
					:selected-component-id="selectedComponentId">
				</bid-tree-node>
			</li>
		</ul>
		<hr v-if="!isLastOne" style="margin: 0;">
	</div>
</template>

<script type="text/javascript">
	
export default {
	name: "BidTreeNode",
	props: [
		"component",
		"selectedComponentId",
		"isLastOne"
	]
}
</script>

<style type="text/css" scoped>
	.node-children {
		padding-left: 15px;
		list-style: none;
	}
</style>